import { TableColumn } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { deviceTypeTableIcon } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { CommDeviceIdColumnComponent } from 'src/app/pages/equipment/devices/components/column/comm-device-id-column.component';
import { SerialNumberColumnComponent } from 'src/app/pages/equipment/devices/components/column/serial-number-column.component';
import { History } from '../services/history-api.types';
import { HistoryValuesComponent } from '../components/history-values/history-values.component';

export const createHistoryLogColumns = (): TableColumn[] => [
  {
    field: 'commDeviceId',
    title: TranslateRegistry.get.HISTORY_LOG.TABLE.COMM_DEVICE_ID,
    sortable: false,
    width: 200,
    cmp: CommDeviceIdColumnComponent
  },
  {
    field: 'serialNumber',
    title: TranslateRegistry.get.HISTORY_LOG.TABLE.SERIAL_NUMBER,
    sortable: false,
    width: 200,
    cmp: SerialNumberColumnComponent
  },
  {
    field: 'meterNumber',
    title: TranslateRegistry.get.HISTORY_LOG.TABLE.INVENTORY_ID,
    sortable: true,
    width: 200,
    text: (dataItem: History): string => `${dataItem.meterNumber ?? ''}`
  },
  {
    field: 'dateTimeUtcSet',
    title: TranslateRegistry.get.HISTORY_LOG.TABLE.DATE_TIME,
    width: 200,
    sortable: true,
    isRightAligned: true
  },
  {
    field: 'updateTypeName',
    title: TranslateRegistry.get.HISTORY_LOG.TABLE.UPDATE_TYPE,
    width: 200,
    sortable: false
  },
  {
    field: 'merged',
    title: TranslateRegistry.get.HISTORY_LOG.TABLE.UPDATED_VALUE,
    width: 400,
    minResizableWidth: 104,
    sortable: false,
    cmp: HistoryValuesComponent
  },
  {
    field: 'deviceTypeName',
    title: TranslateRegistry.get.HISTORY_LOG.TABLE.DEVICE_TYPE,
    width: 200,
    sortable: true,
    icon: deviceTypeTableIcon
  },
  { field: 'modelName', title: TranslateRegistry.get.HISTORY_LOG.TABLE.MODEL_NAME, width: 200, sortable: true },
  { field: 'updatedBy', title: TranslateRegistry.get.HISTORY_LOG.TABLE.UPDATED_BY, width: 200, sortable: true }
];
